<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    @delete-open-action="loadServerEntry(entry.id)"
    deleteTitle="Fechamento Manual de Pedido de Venda"
    :formErrors="formErrors"
    ref="baseDelete"
    deleteConfirmButtonLabel="Fechar Pedido de Venda"
    deleteIcon="mdi-check"
    deleteButtonLabel="Fechar Pedido de Venda"
    deleteColor="orange"
    :alwaysEnabled="true"
  >
    <p>Você tem certeza que deseja fechar manualmente este pedido de venda?</p>
    <p>Obs.: Os produtos de venda em aberto não irão mais aparecer no relatório de disponibilidade de produção.</p>

    <v-row>
      <v-col cols="12" v-if="editableEntry">
        <v-textarea
          v-model="editableEntry.observation"
          label="Descreva o motivo do fechamento manual deste pedido de venda."
          outlined
          required
          autocomplete="off"
        ></v-textarea>
      </v-col>

    </v-row>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: [],
      editableEntry: null,
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALE_ORDER_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.saleOrder;
          // this.extraData = response.data;
          // console.log("saleOrder edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    destroyServerEntry: function(saleOrder) {
      // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: CLOSE_SALE_ORDER_MUTATION,
            variables: {
              input: this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations)
            }
          })
          .then(response => {
            var errors = response.data.closeSaleOrder.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.editableEntry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const CLOSE_SALE_ORDER_MUTATION = gql `
  mutation($input: SaleOrderUpdateInputObject!) {
    closeSaleOrder(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

const LOAD_SALE_ORDER_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      saleOrder(id: $id) {
        id
        code
        billDate
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        customerId
        totalPrice
        observation
        validations
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          itemId
          storageId
          isNewItemInStorage
          unitPrice
          item {
            id
            name
            description
            unit {
              name
            }
          }
          storage {
            id
            name
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allCustomers {
        id
        name
      }
      allCarriers {
        id
        name
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

</script>

<style scoped></style>
